import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import layout from './modules/layout'
import locations from './modules/locations'
import accounts from './modules/accounts'
import tasks from './modules/tasks'
import keywords from './modules/keywords'
import automaticResponse from './modules/automaticResponse'
import reviews from './modules/reviews'
import notifications from './modules/notifications'
import posts from './modules/posts'
import locationCoverPhotos from './modules/locationCoverPhotos'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    auth,
    layout,
    locations,
    accounts,
    tasks,
    keywords,
    reviews,
    notifications,
    posts,
    locationCoverPhotos,
    automaticResponse
  },
  strict: debug,
  plugins: []
})